import getUserFullName from './getUserFullName'

export default function getUserLabel(user) {
  if (!user) {
    return null
  }
  const fullName = getUserFullName(user)

  return fullName || user.username || user.email
}
